module.exports = __webpack_public_path__ + "media/logo/menu-icon-3616f476.png";